
import Vue from "vue";
import { mapGetters } from "vuex";
import { MenuItem } from "@/types";
import { menuItems } from "@/config/menuItems";

export default Vue.extend({
  computed: {
    ...mapGetters("auth", ["userHasPermission"]),
    menuItems(): MenuItem[] {
      return menuItems.map((item) => {
        if (
          item.module &&
          item.role &&
          !this.userHasPermission(item.module, item.role)
        ) {
          item.hidden = true;
        } else item.hidden = false;
        return item;
      });
    },
  },
});
